import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { AppBar, Toolbar, Typography, Box, Menu, MenuItem, IconButton, useMediaQuery } from "@mui/material";
import { Mail, Person } from "@mui/icons-material";
import OptumRxLogo from "../../Assets/Images/logo-optumrx.png";
import MenuIcon from '@mui/icons-material/Menu';
import { currentScreen } from "../Redux/ResolutionSlice";
import { currentTabIndex } from "../Redux/TabIndexSlice";
import { mnrTabIndex } from "../Redux/TabIndexSlice";
import './Header.css'

function Header() {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const cns = useSelector(state => state.role.cns);
    const mnr = useSelector(state => state.role.mnr);
    const reports = useSelector(state => state.role.reports);

    useEffect(() => {
        dispatch(currentScreen(isSmallScreen));
    }, [dispatch, isSmallScreen])

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleMenuItemClick = (index) => {
        handleMenuClose();
        dispatch(currentTabIndex(index));
        dispatch(mnrTabIndex(0));
    };

    return (
        <>
            <AppBar style={{ background: 'rgb(251, 249, 244)', height: '50px', paperShadow: 'none', position: 'absolute' }} elevation={0}>
                <Toolbar>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        <img src={OptumRxLogo} alt="Optum" style={{ width: 140 }} />
                    </Typography>
                    <Box display={{ xs: 'none', md: 'contents' }}>
                        <Person className="tab-icon" />
                        <Typography className="tab-typography"
                            noWrap
                            style={{
                                marginRight: "25px",
                                fontFamily: 'var(--font-family-base)'
                            }}
                        >
                            {localStorage.getItem("email")}
                            {/* {"Balaji, Priyanka"} */}
                        </Typography>
                        <Mail className="tab-icon" />
                        <Typography className="tab-typography"
                            style={{
                                fontFamily: 'var(--font-family-base)'
                            }}
                        >
                            {localStorage.getItem("name")}
                            {/* {"priyanka.balaji2@optum.com"} */}
                        </Typography>
                    </Box>
                    {
                        isSmallScreen && <>
                            <div>
                                <IconButton onClick={handleMenuOpen}>
                                    <MenuIcon />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={handleMenuClose}
                                    PaperProps={{
                                        sx: {
                                            maxHeight: 'calc(100% - 32px)'
                                        },
                                    }}
                                >

                                    {/* {(() => {
                                        const items = [];
                                        let indexCount = -1;
                                        if (cns || cnsAndMnr) {
                                            items.push(
                                                <MenuItem key="pa" onClick={() => handleMenuItemClick(indexCount)}>PA Extensions</MenuItem>,
                                                <MenuItem key="rejected" onClick={() => handleMenuItemClick(indexCount + 1)}>Rejected Extensions</MenuItem>,
                                                <MenuItem key="config" onClick={() => handleMenuItemClick(indexCount + 2)}>Configurations</MenuItem>
                                            );
                                            indexCount += 3;
                                        }
                                        if (mnr || cnsAndMnr) {
                                            // Fallback to old MNR link if reports flag not enabled
                                            items.push(
                                                <MenuItem key="mnr" onClick={() => handleMenuItemClick(indexCount)}>MNR</MenuItem>
                                            );
                                            indexCount += 1;
                                        }
                                        if (reports) {
                                            items.push(
                                                <MenuItem key="reports" onClick={() => handleMenuItemClick(indexCount)}>Reports</MenuItem>,
                                                <MenuItem key="cocaAnnual" onClick={() => handleMenuItemClick(indexCount + 1)}>Coca Annual</MenuItem>
                                            );
                                            indexCount += 2;
                                        }

                                        return items;
                                    })()
                                    } */}
                                    {
                                        (() => {
                                            const menuLabels = [];

                                            if (cns) {
                                                menuLabels.push("PA Extensions", "Rejected Extensions", "Configurations");
                                            }
                                            if (mnr) {
                                                menuLabels.push("MNR");
                                            }
                                            if (reports) {
                                                menuLabels.push("Reports", "Coca Annual");
                                            }

                                            const items = menuLabels.map((label, index) => (
                                                <MenuItem key={label} onClick={() => handleMenuItemClick(index)}>
                                                    {label}
                                                </MenuItem>
                                            ));
                                            return items;
                                        })()
                                    }
                                </Menu>
                            </div>
                        </>
                    }
                </Toolbar>
            </AppBar >
        </>
    )
}

export default Header